// Nav: composable navigation. Uses NavLink so the active class comes from the router.

import { useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Btn } from '@ui/library';
import { cx } from '@lib/utils/classNames';

export interface NavProps {
  pages: ReadonlyArray<readonly [string, string]>;
  calendlyHref: string;
  brandHref?: string;
  logoSrc?: string;
}

export function Nav({
  pages,
  calendlyHref,
  brandHref = '/',
  logoSrc = '/assets/logo-monogram.svg',
}: NavProps) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes.
  const handleNavigate = () => setOpen(false);

  return (
    <nav className="nav" key={location.pathname}>
      <div className="wrap nav__inner">
        <Link className="brand" to={brandHref} onClick={handleNavigate}>
          <img src={logoSrc} alt="" />
          <b>alison&nbsp;haire<span className="dot">.</span></b>
        </Link>
        <div className={cx('nav__links', open && 'open')}>
          {pages.map(([label, href]) => (
            <NavLink
              key={label}
              to={href}
              className={({ isActive }) => cx('navlink', isActive && 'active')}
              onClick={handleNavigate}
            >
              {label}
            </NavLink>
          ))}
          <Btn kind="primary" href={calendlyHref} icon="calendar-check" target="_blank">
            Book a time
          </Btn>
        </div>
        <button
          className="nav__burger"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
